import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

let routes = [
	{
		// will match everything
		path: '*',
		component: () => import('../views/404.vue'),
	},
	{
		path: '/',
		name: 'Home',
		redirect: '/dashboards/',
	},
	{
		path: '/authentication',
		name: 'Authentication',
		component: () => import('../views/Authentication/Authentication.vue'),
		children: [
			{
				path: 'login',
				name: 'Login',
				meta: {
					layoutClass: 'layout-sign-up-cover',
					title: 'Login',
					sidebarMap: ['authentication', 'sign-up', 'cover'],
					breadcrumbs: ['Authentication', 'Sign Up', 'Cover'],
				},
				component: () => import('../views/Authentication/Login.vue'),
			},
		]
	},
	{
		path: '/dashboards',
		name: 'Dashboard',
		layout: "dashboard",
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/Dashboards/Dashboard.vue'),
		children: [
			{
				path: '/',
				// route level code-splitting
				// this generates a separate chunk (about.[hash].js) for this route
				// which is lazy-loaded when the route is visited.
				meta: {
					title: 'Dashboard',
					sidebarMap: ['dashboards'],
					breadcrumbs: ['Dashboards', 'Default'],
				},
				component: () => import(/* webpackChunkName: "dashboard" */ '../views/Dashboards/Default.vue'),
			},
			{
				path: 'koas/timeline/:id',
				name: 'Timeline Koas',
				meta: {
					title: 'Timeline',
					sidebarMap: ['dashboards', 'koas', 'timeline'],
					breadcrumbs: ['Dashboards', 'Koas', 'Timeline'],
				},
				component: () => import('../views/Dashboards/Koas/DashboardKoasTimeline.vue'),
			},
			{
				path: 'dpjp/timeline/:id',
				name: 'Timeline',
				meta: {
					title: 'Timeline',
					sidebarMap: ['dashboards', 'dpjp', 'timeline'],
					breadcrumbs: ['Dashboards', 'DPJP', 'Timeline'],
				},
				component: () => import('../views/Dashboards/Timeline.vue'),
			},
			{
				path: 'format-kerja/:id',
				name: 'FormatKerja',
				meta: {
					title: 'Format Kerja',
					sidebarMap: ['dashboards', 'format-kerja'],
					breadcrumbs: ['Dashboards', 'Format Kerja'],
				},
				component: () => import('../views/Dashboards/EmbedFormatKerja.vue'),
			},
			{
				path: 'format-kerja-dpjp/:id',
				name: 'FormatKerjaDpjp',
				meta: {
					title: 'Format Kerja DPJP',
					sidebarMap: ['dashboards', 'format-kerja-dpjp'],
					breadcrumbs: ['Dashboards', 'Format Kerja DPJP'],
				},
				component: () => import('../views/Dashboards/EmbedFormatKerjaDokter.vue'),
			},
			{
				path: 'history-format-kerja',
				name: 'HistoryFormatKerja',
				meta: {
					title: 'History Format Kerja',
					sidebarMap: ['dashboards', 'history-format-kerja'],
					breadcrumbs: ['Dashboards', 'History Format Kerja'],
				},
				component: () => import('../views/Dashboards/Koas/ListWorkingFormatKoas.vue'),
			},
			{
				path: 'history-format-kerja-admin',
				name: 'HistoryFormatKerjaAdmin',
				meta: {
					title: 'History Format Kerja',
					sidebarMap: ['dashboards', 'history-format-kerja-admin'],
					breadcrumbs: ['Dashboards', 'History Format Kerja Admin'],
				},
				component: () => import('../views/Dashboards/Admin/ListWorkingFormatAdmin.vue'),
			},
			{
				path: 'tindakan',
				name: 'Tindakan',
				meta: {
					title: 'History Tindakan',
					sidebarMap: ['dashboards', 'tindakan'],
					breadcrumbs: ['Dashboards', 'Tindakan'],
				},
				component: () => import('../views/Dashboards/Koas/ListTindakanKoas.vue'),
			},
			{
				path: 'billing',
				name: 'Billing',
				meta: {
					title: 'History Billing',
					sidebarMap: ['dashboards', 'billing'],
					breadcrumbs: ['Dashboards', 'Billing'],
				},
				component: () => import('../views/Dashboards/Koas/ListBillingKoas.vue'),
			},
			{
				path: 'billing-admin',
				name: 'BillingAdmin',
				meta: {
					title: 'History Billing',
					sidebarMap: ['dashboards', 'billing-admin'],
					breadcrumbs: ['Dashboards', 'Billing-admin'],
				},
				component: () => import('../views/Dashboards/Admin/ListBillingAdmin.vue'),
			},
			{
				path: 'history-booking',
				name: 'HistoryBooking',
				meta: {
					title: 'History Booking',
					sidebarMap: ['dashboards', 'history-booking'],
					breadcrumbs: ['Dashboards', 'History Booking'],
				},
				component: () => import('../views/Dashboards/Koas/ListBookingKoas.vue'),
			},
			{
				path: 'billing-dpjp',
				name: 'BillingDPjp',
				meta: {
					title: 'History Billing Koas',
					sidebarMap: ['dashboards', 'billing'],
					breadcrumbs: ['Dashboards', 'Billing'],
				},
				component: () => import('../views/Dashboards/Dokter/ListBillingDokter.vue'),
			},
			{
				path: 'settings',
				name: 'Settings',
				meta: {
					title: 'Settings',
					sidebarMap: ['pages', 'account', 'settings'],
					breadcrumbs: ['Pages', 'Account', 'Settings'],
				},
				component: () => import('../views/Settings/Settings.vue'),
			},
			{
				path: 'dpjp/penilaian/:id/:partner',
				name: 'Penilaian',
				meta: {
					title: 'Penilaian',
					sidebarMap: ['dashboards', 'penilaian'],
					breadcrumbs: ['Dashboards', 'Penilaian'],
				},
				component: () => import('../views/Dashboards/Dokter/Penilaian.vue'),
			},
			{
				path: 'koas/penilaian/:id',
				name: 'Penilaian',
				meta: {
					title: 'Penilaian',
					sidebarMap: ['dashboards', 'penilaian'],
					breadcrumbs: ['Dashboards', 'Penilaian'],
				},
				component: () => import('../views/Dashboards/Koas/PenilaianKoas.vue'),
			},
			{
				path: 'penilaian/:id/:partner',
				name: 'Penilaian',
				meta: {
					title: 'Penilaian',
					sidebarMap: ['dashboards', 'penilaian'],
					breadcrumbs: ['Dashboards', 'Penilaian'],
				},
				component: () => import('../views/Dashboards/ViewPenilaian.vue'),
			},
			{
				path: 'jadwal-dpjp',
				name: 'Jadwal DPJP',
				meta: {
					title: 'Jadwal DPJP',
					sidebarMap: ['dashboards', 'jadwal-dpjp'],
					breadcrumbs: ['Dashboards', 'Jadwal DPJP'],
				},
				component: () => import('../views/Dashboards/Admin/JadwalDokterAdmin.vue'),
			},
			{
				path: 'management',
				name: 'Management',
				component: () => import(/* webpackChunkName: "dashboard" */ '../views/Dashboards/Management.vue'),
				children: [
					{
						path: 'koas',
						name: 'Koas',
						meta: {
							title: 'Manajemen Koas',
							sidebarMap: ['dashboards', 'management', 'koas'],
							breadcrumbs: ['Dashboards', 'Management', 'Koas'],
						},
						component: () => import('../views/Dashboards/Admin/ListKoas.vue'),
					},
					{
						path: 'dpjp',
						name: 'DPJP',
						meta: {
							title: 'Manajemen DPJP',
							sidebarMap: ['dashboards', 'management', 'dpjp'],
							breadcrumbs: ['Dashboards', 'Management', 'DPJP'],
						},
						component: () => import('../views/Dashboards/Admin/ListDpjp.vue'),
					},
					{
						path: 'user',
						name: 'User',
						meta: {
							title: 'Manajemen User',
							sidebarMap: ['dashboards', 'management', 'user'],
							breadcrumbs: ['Dashboards', 'Management', 'User'],
						},
						component: () => import('../views/Dashboards/Admin/ListUser.vue'),
					},
					{
						path: 'klinik',
						name: 'Klinik',
						meta: {
							title: 'Manajemen Klinik',
							sidebarMap: ['dashboards', 'management', 'klinik'],
							breadcrumbs: ['Dashboards', 'Management', 'Klinik'],
						},
						component: () => import('../views/Dashboards/Admin/ListKlinik.vue'),
					},
				]
			},
			{
				path: 'evaluasi',
				name: 'Evaluasi',
				meta: {
					title: 'Evaluasi Booking',
					sidebarMap: ['dashboards', 'evaluasi'],
					breadcrumbs: ['Dashboards', 'Evaluasi Booking'],
				},
				component: () => import('../views/Dashboards/Evaluasi/EvaluasiBooking.vue'),
			},
			{
				path: 'dbcompare',
				name: 'Db Structure Compare',
				meta: {
					title: 'Db Structure Compare',
					sidebarMap: ['dashboards', 'dbcompare'],
					breadcrumbs: ['Dashboards', 'Db Structure Compare'],
				},
				component: () => import('../views/Dashboards/Dev/DbStructureCompare.vue'),
			},
			{
				path: 'dbcopy',
				name: 'Db Copy Data',
				meta: {
					title: 'Db Copy Data',
					sidebarMap: ['dashboards', 'dbcopy'],
					breadcrumbs: ['Dashboards', 'Db Copy Data'],
				},
				component: () => import('../views/Dashboards/Dev/DbCopyData.vue'),
			},
			{
				path: 'edit_booking/:id',
				name: 'Edit Booking',
				meta: {
					title: 'Edit Booking',
					sidebarMap: ['dashboards', 'edit_booking'],
					breadcrumbs: ['Dashboards', 'Edit Booking'],
				},
				component: () => import('../views/Dashboards/Admin/EditBooking.vue'),
			},
		]
	},
	{
		path: '/layout',
		name: 'Layout',
		layout: "dashboard",
		component: () => import('../views/Layout.vue'),
	},
	{
		path: '/history-format-kerja/:id',
		name: 'DetailHistoryFormatKerja',
		meta: {
			title: 'Detail History Format Kerja',
			sidebarMap: ['dashboards', 'detail-history-format-kerja'],
			breadcrumbs: ['Dashboards', 'Detail History Format Kerja'],
		},
		component: () => import('../views/Dashboards/Koas/DetailWorkingFormatKoas.vue'),
	},
]

// Adding layout property from each route to the meta
// object so it can be accessed later.
function addLayoutToRoute( route, parentLayout = "default" )
{
	route.meta = route.meta || {} ;
	route.meta.layout = route.layout || parentLayout ;
	
	if( route.children )
	{
		route.children = route.children.map( ( childRoute ) => addLayoutToRoute( childRoute, route.meta.layout ) ) ;
	}
	return route ;
}

routes = routes.map( ( route ) => addLayoutToRoute( route ) ) ;

const router = new VueRouter({
	mode: 'hash',
	base: process.env.BASE_URL,
	routes,
	scrollBehavior (to, from, savedPosition) {
		if ( to.hash ) {
			return {
				selector: to.hash,
				behavior: 'smooth',
			}
		}
		return {
			x: 0,
			y: 0,
			behavior: 'smooth',
		}
	}
})

export default router
